import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Row } from "react-bootstrap";
import "../assets/styles/AiImageModel.css";
import texticon from "../assets/images/texticon.svg";
import uploadimage from "../assets/images/uploadimage.svg";
import textcolorchange from "../assets/images/textcolorchange.svg";
import deleteai from "../assets/images/deleteai.svg";
import Right from "../assets/images/Right.svg";
import Left from "../assets/images/Left.svg";

const EditAIImageModal = (props) => {
  const [textElement, setTextElement] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [editing, setEditing] = useState(false);
  const [newText, setNewText] = useState("");
  const [TextShow, setTextShow] = useState(false);
  const [ImageIndex1, setImageIndex1] = useState(null);
  const [TextFeatureShow, setTextFeatureShow] = useState(false);
  const [ImageFeatureShow, setImageFeatureShow] = useState(false);
  const [ImageShow, setImageShow] = useState(false);
  const [fontSize, setFontSize] = useState(20);
  const [fontColor, setFontColor] = useState("#000000");
  const [fontFamily, setFontFamily] = useState("Arial");
  const [history, setHistory] = useState([]);
  const canvasRef = useRef(null);
  const [isResizing, setIsResizing] = useState(null);
  const [resizeData, setResizeData] = useState(null);
  const containerRef = useRef(null);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [draggedImageIndex, setDraggedImageIndex] = useState(null); // Track the dragged image index

  useEffect(() => {
    if (props?.data) {
      drawImageOnCanvas(props?.data); // Call drawImageOnCanvas on initial image load
    }
  }, [props?.data]); // Dependency on props.data.name
  const applyStyle = (command, value) => {
    document.execCommand(command, false, value);
  };
  const handleFontChange = (e) => {
    setFontFamily(e.target.value);
    applyStyle("fontName", e.target.value);
  };
  const handleFontSizeChange = (e) => {
    setFontSize(Number(e));
    applyStyle("fontSize", Number(e));
  };
  const handleColorChange = (e) => {
    setFontColor(e.target.value);
    applyStyle("foreColor", e.target.value);
  };
  const drawImageOnCanvas = (imageUrl) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const image = new Image();
    image.src = imageUrl; // Use the provided imageUrl
    image.onload = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      if (textElement) {
        // Draw existing text elements on image load
        const { text, x, y, fontSize, rotation, color, fontFamily } =
          textElement;
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate((rotation * Math.PI) / 180);
        ctx.font = `${fontSize}px ${fontFamily}`;
        ctx.fillStyle = color;
        ctx.fillText(text, 0, 0);
        ctx.restore();
      }
    };
  };
  const handleAddText = () => {
    setNewText("");
    setTextElement(null);
    // setHistory([]);
    // if (!newText.trim()) return;
    const newElement = {
      text: newText,
      x: 100,
      y: 100,
      fontSize,
      rotation: 0,
      color: fontColor,
      fontFamily,
    };
    setHistory([...history, textElement]);
    setTextElement(newElement);
    setTextShow(true);
    setTextFeatureShow(true);
    setImageFeatureShow(false);
    setImageIndex1(null);
  };
  const handleRotateImage = (index, direction) => {
    const updatedImages = [...uploadedImages];
    updatedImages[index].rotation += direction === "clockwise" ? 15 : -15;
    setUploadedImages(updatedImages);
  };
  const handleUploadImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const image = new Image();
    const reader = new FileReader();
    reader.onload = (event) => {
      image.src = event.target.result;
      image.onload = () => {
        const newImage = {
          image,
          x: 200,
          y: 200,
          width: 100,
          height: 100,
          rotation: 0,
        };
        setHistory([
          ...history,
          { type: "image", images: [...uploadedImages] },
        ]);
        setUploadedImages([...uploadedImages, newImage]);
        setImageIndex1(uploadedImages?.length > 0 ? uploadedImages?.length : 0);
        setTextFeatureShow(false);
      };
    };
    reader.readAsDataURL(file);
    setImageShow(!ImageShow);
    setImageFeatureShow(true);
    setTextFeatureShow(false);
  };
  const handleDeleteImage = (index) => {
    const updatedImages = uploadedImages.filter((_, i) => i !== index);
    setHistory([...history, { type: "image", images: [...uploadedImages] }]);
    setUploadedImages(updatedImages);
  };
  const handleDeleteText = () => {
    setHistory([...history, textElement]);
    setTextElement(null);
    setTextShow(!TextShow);
  };
  const handleMouseDown = (e, index = null) => {
    setImageIndex1(index);
    setTextFeatureShow(false);
    setDragging(true);
    if (index !== null) {
      setDraggedImageIndex(index);
    } else {
      setDraggedImageIndex(null);
    }
  };
  const handleMouseMove = (e) => {
    // setImageIndex1(index);
    if (!dragging) return;
    const container = containerRef.current.getBoundingClientRect();
    const newX = e.clientX - container.left;
    const newY = e.clientY - container.top;
    if (draggedImageIndex !== null) {
      const updatedImages = [...uploadedImages];
      updatedImages[draggedImageIndex] = {
        ...updatedImages[draggedImageIndex],
        x: newX,
        y: newY,
      };
      setUploadedImages(updatedImages);
    } else if (textElement) {
      setTextElement({ ...textElement, x: newX, y: newY });
    }
  };
  const handleMouseUp = () => {
    setDragging(false);
    setDraggedImageIndex(null);
  };
  const handleRotateText = (direction) => {
    if (textElement) {
      const newRotation =
        direction === "clockwise"
          ? textElement.rotation + 15
          : textElement.rotation - 15;
      setHistory([...history, textElement]);
      setTextElement({ ...textElement, rotation: newRotation });
    }
  };
  const handleTextChange = (e) => {
    setNewText(e.target.value);
  };
  const handleUndo = () => {
    if (history.length > 0) {
      const previousState = history.pop();
      setTextElement(previousState);
      setHistory(history);
    }
  };
  function blobToBase64WithType(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // Directly return the full Base64 string
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(blob); // Read the Blob as a data URL
    });
  }
  async function convertBlob(blob) {
    try {
      const base64String = await blobToBase64WithType(blob);
      return base64String; // You can return this for further use
    } catch (error) {
      console.error("Error converting blob to Base64 with type:", error);
    }
  }
  const handleSaveImage = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    // Clear the canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // Draw the main image (if available)
    if (props?.data) {
      const mainImage = new Image();
      mainImage.src = props.data;
      mainImage.onload = () => {
        ctx.drawImage(mainImage, 0, 0, canvas.width, canvas.height);
        // Draw each uploaded image on the canvas
        uploadedImages.forEach((img) => {
          ctx.save();
          ctx.translate(img.x + img.width / 2, img.y + img.height / 2); // Translate to image center
          ctx.rotate((img.rotation * Math.PI) / 180); // Apply rotation
          ctx.drawImage(
            img.image,
            -img.width / 2,
            -img.height / 2,
            img.width,
            img.height
          ); // Draw image centered
          ctx.restore();
        });
        // Draw the text element on the canvas
        if (textElement) {
          ctx.save();
          ctx.font = `${fontSize}px ${fontFamily}`;
          ctx.fillStyle = fontColor;
          ctx.translate(textElement.x, textElement.y);
          ctx.rotate((textElement.rotation * Math.PI) / 180);
          ctx.fillText(textElement.text, 0, 0);
          ctx.restore();
        }
        canvas.toBlob(async (blob) => {
          let baseImg = await convertBlob(blob);
          const imageIndex = props?.images.findIndex(
            (item, index) => index === props?.imageindex
          );
          if (imageIndex !== -1) {
            const updatedImages = [...props?.images];
            updatedImages[imageIndex] = baseImg;
            props?.setimages(updatedImages);
          }
          props.onHide();
        }, "image/png");
      };
    }
  };

  // resize code
  const handleResizeMouseMove = (e) => {
    if (isResizing !== null) {
      const { startX, startY, startWidth, startHeight, index } = resizeData;

      const newWidth = startWidth + (e.clientX - startX);
      const newHeight = startHeight + (e.clientY - startY);

      if (newWidth > 50 && newHeight > 50) {
        const updatedImages = [...uploadedImages];
        updatedImages[index].width = newWidth;
        updatedImages[index].height = newHeight;
        setUploadedImages(updatedImages);
      }
    }
  };

  const handleResizeMouseUp = () => {
    setIsResizing(null); // Reset resizing state
  };

  const handleResizeMouseLeave = () => {
    setIsResizing(null); // Stop resizing when the mouse leaves
  };
  const handleResizeStart = (e, index) => {
    e.stopPropagation();
    setIsResizing(index);
    const startX = e.clientX;
    const startY = e.clientY;
    const startWidth = uploadedImages[index].width;
    const startHeight = uploadedImages[index].height;

    setResizeData({ startX, startY, startWidth, startHeight, index });
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="edit-ai-image-model"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Edit AI Image
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <div className="d-flex gap-2 align-items-center">
            {/* <input
              type="text"
              value={newText}
              onChange={handleTextChange}
              placeholder="Enter new text"
              style={{ marginRight: "10px", fontFamily: fontFamily }}
            /> */}
            <button
              className="blue-btn w-auto uploadimage-ai d-flex gap-1 align-items-center"
              onClick={handleAddText}
            >
              <img src={texticon} alt="texticon"></img>
              Add a Text Box
            </button>
            <button
              className="blue-btn w-auto uploadimage-ai  d-flex gap-2"
              onClick={(e) => {
                setTextFeatureShow(false);
                // e.preventDefault();
                if (newText === "") {
                  setTextShow(false);
                }
              }}
            >
              <img src={uploadimage} alt="uploadimage"></img>
              Upload Image
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  handleUploadImage(e);
                }}
                // style={{ marginLeft: "10px" }}
              />
            </button>

            {TextFeatureShow && (
              <div className=" textfeacture-inner">
                <select
                  id="font-select"
                  value={fontFamily}
                  onChange={handleFontChange}
                  className="ms-1"
                  // style={{
                  //   fontFamily: fontFamily,
                  //   fontSize: "20px",
                  //   color: "black",
                  //   // marginTop: "20px",
                  //   padding: "5px",
                  // }}
                >
                  <option value="">Default</option>
                  <option
                    value="Roboto"
                    style={{ fontFamily: "'Roboto', sans-serif" }}
                  >
                    Roboto
                  </option>
                  <option
                    value="Poppins"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    Poppins
                  </option>
                  <option
                    value="Open Sans"
                    style={{ fontFamily: "'Open Sans', sans-serif" }}
                  >
                    Open Sans
                  </option>
                  <option
                    value="Lato"
                    style={{ fontFamily: "'Lato', sans-serif" }}
                  >
                    Lato
                  </option>
                  <option
                    value="Montserrat"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    Montserrat
                  </option>
                  <option
                    value="Oswald"
                    style={{ fontFamily: "'Oswald', sans-serif" }}
                  >
                    Oswald
                  </option>
                  <option
                    value="Raleway"
                    style={{ fontFamily: "'Raleway', sans-serif" }}
                  >
                    Raleway
                  </option>
                  <option
                    value="Merriweather"
                    style={{ fontFamily: "'Merriweather', serif" }}
                  >
                    Merriweather
                  </option>
                  <option
                    value="Nunito"
                    style={{ fontFamily: "'Nunito', sans-serif" }}
                  >
                    Nunito
                  </option>
                  <option
                    value="Playfair Display"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    Playfair Display
                  </option>
                  <option
                    value="Noto Sans"
                    style={{ fontFamily: "'Noto Sans', sans-serif" }}
                  >
                    Noto Sans
                  </option>
                  <option
                    value="PT Sans"
                    style={{ fontFamily: "'PT Sans', sans-serif" }}
                  >
                    PT Sans
                  </option>
                  <option
                    value="Source Sans Pro"
                    style={{ fontFamily: "'Source Sans Pro', sans-serif" }}
                  >
                    Source Sans Pro
                  </option>
                  <option
                    value="Ubuntu"
                    style={{ fontFamily: "'Ubuntu', sans-serif" }}
                  >
                    Ubuntu
                  </option>
                  <option
                    value="Georgia"
                    style={{ fontFamily: "'Georgia', serif" }}
                  >
                    Georgia
                  </option>
                </select>
                <input
                  className="numbersize-inner-ai"
                  type="number"
                  value={fontSize}
                  onChange={(e) => {
                    handleFontSizeChange(e.target.value);
                  }}
                  min="10"
                  max="100"
                  placeholder="Font size"
                  // style={{ marginRight: "10px", padding: "5px"}}
                />
                

                <div className="color-picker-block-ai" >
                <div className="color-picker-icon-ai"></div>
                <input
                  className="color-picker"
                  type="color"
                  value={fontColor}
                  onChange={(e) => handleColorChange(e)}
                  // style={{ marginRight: "10px",  }}
                />

                 </div>

                <div
                  // style={{
                  //   position: "absolute",
                  //   top: "-20px",
                  //   right: "-60px",
                  //   display: "flex",
                  //   gap: "5px",
                  // }}
                  className="rotate-all-button"
                >
                  <span
                    className="rotate-all-left"
                    onClick={() => handleRotateText("clockwise")}
                    // style={{
                    //   background: "green",
                    //   color: "white",
                    //   padding: "5px",
                    //   borderRadius: "50%",
                    //   cursor: "pointer",
                    // }}
                  >
                   <img src={Right} alt="Right" />
                  </span>
                  <span
                    className="rotate-all-right"
                    onClick={() => handleRotateText("counterclockwise")}
                    // style={{
                    //   background: "blue",
                    //   color: "white",
                    //   padding: "5px",
                    //   borderRadius: "50%",
                    //   cursor: "pointer",
                    // }}
                  >
                   
                   <img src={Left} alt="Left" />
                  </span>
                  <span
                    className="rotate-all-delete"
                    onClick={handleDeleteText}
                    // style={{
                    //   background: "red",
                    //   color: "white",
                    //   padding: "5px",
                    //   borderRadius: "50%",
                    //   cursor: "pointer",
                    // }}
                  >
                    <img src={deleteai} alt="deleteai" />
                  </span>
                </div>
              </div>
            )}

            {ImageIndex1 !== null && ImageIndex1 !== undefined && (
              <div
                className="rotate-all-button ai-edite-img"
                // style={{
                //   position: "absolute",
                //   top: "-20px",
                //   right: "-60px",
                //   display: "flex",
                //   gap: "5px",
                // }}
              >
                <span  className="rotate-all-left"
                  onClick={() => handleRotateImage(ImageIndex1, "clockwise")}
                  // style={{
                  //   background: "white",
                  //   color: "black",
                  //   padding: "5px",
                  //   // borderRadius: "50%",
                  //   cursor: "pointer",
                  //   fontsize: "20px",
                  //   fontweight: " 500",
                  // }}
                >
             
                 <img src={Right} alt="Right" />
                </span>
                <span className="rotate-all-right"
                  onClick={() =>
                    handleRotateImage(ImageIndex1, "counterclockwise")
                  }
                  // style={{
                  //   background: "white",
                  //   color: "black",
                  //   padding: "5px",
                  //   // borderRadius: "50%"
                  //   cursor: "pointer",
                  //   fontsize: "20px",
                  //   fontweight: " 500",
                  // }}
                >
                       <img src={Left} alt="Left" />
                </span>
                <span className="rotate-all-delete"
                  onClick={() => handleDeleteImage(ImageIndex1)}
                  // style={{
                  //   // background: "red",
                  //   // color: "white",
                  //   padding: "5px",
                  //   borderRadius: "50%",
                  //   cursor: "pointer",
                  // }}
                >
                  <img src={deleteai} alt="deleteai" />
                </span>
              </div>
            )}
          </div>
          <div
            ref={containerRef}
            style={{
              position: "relative",
              width: "1000px",
              height: "450px",
              margin: "12px auto",
              // border: "1px solid black",
            }}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
          >
            <canvas
              ref={canvasRef}
              width={1000}
              height={450}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
              onMouseDown={handleMouseDown}
            />
            {textElement && (
              <div className=""
                style={{
                  position: "absolute",
                  top: textElement.y,
                  left: textElement.x,
                  transform: `rotate(${textElement.rotation}deg)`,
                  cursor: "move",
                  zIndex: 2,
                }}
                onMouseDown={handleMouseDown}
              >
                {editing ? (
                  <input
                    type="text"
                    className="aiimage-edite-text-inner"
                    placeholder="Enter Your Text Here..."
                    value={textElement.text}
                    onChange={(e) => {
                      handleTextChange(e);
                      setTextElement({ ...textElement, text: e.target.value });
                    }}
                    onBlur={() => {
                      setEditing(false);
                    }}
                    style={{
                      fontSize: `${fontSize}px`,
                      color: fontColor,
                      fontFamily: fontFamily,
                      background: "transparent",
                      // border:"none",
                      border: "2px solid white",
                      minWidth: "300px",
                      minHeight: "30px",
                      padding:"0px 8px",
                      // opacity:"1",
                    }}
                    autoFocus
                  />
                ) : (
                  <>
                    {TextShow && (
                      <div
                        // style={{
                        //   fontSize: `${fontSize}px`,
                        //   color: fontColor,
                        //   fontFamily: fontFamily,
                        //   display: "inline-block",
                        //   position: "relative",
                        // }}
                        style={{
                          fontSize: `${fontSize}px`,
                          color: fontColor,
                          fontFamily: fontFamily,
                          background: "transparent",
                          border: "2px solid white",
                          minWidth: "300px",
                          minHeight: "30px",
                          padding:"0px 8px",
                          // opacity:"0.5"
                        }}
                        onClick={() => {
                          setEditing(true);
                          setTextFeatureShow(true);
                        }}
                      >
                        {textElement.text}

                        {/* <div
                          style={{
                            position: "absolute",
                            top: "-20px",
                            right: "-60px",
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          <span
                            onClick={() => handleRotateText("clockwise")}
                            style={{
                              background: "green",
                              color: "white",
                              padding: "5px",
                              borderRadius: "50%",
                              cursor: "pointer",
                            }}
                          >
                            ↻
                          </span>
                          <span
                            onClick={() => handleRotateText("counterclockwise")}
                            style={{
                              background: "blue",
                              color: "white",
                              padding: "5px",
                              borderRadius: "50%",
                              cursor: "pointer",
                            }}
                          >
                            ↺
                          </span>
                          <span
                            onClick={handleDeleteText}
                            style={{
                              background: "red",
                              color: "white",
                              padding: "5px",
                              borderRadius: "50%",
                              cursor: "pointer",
                            }}
                          >
                            ✖
                          </span>
                        </div> */}
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
            {uploadedImages.map((img, index) => (
              <div
                key={index}
                style={{
                  position: "absolute",
                  top: img.y,
                  left: img.x,
                  transform: `rotate(${img.rotation}deg)`,
                  cursor: "move",
                  zIndex: 2,
                }}
                onMouseDown={(e) => handleMouseDown(e, index)} // Pass the index
              >
                <div
                  style={{
                    display: "inline-block",
                    position: "relative",
                    userSelect: "none",
                    width: `${img.width}px`,
                    height: `${img.height}px`,
                    border: "1px solid #ccc",
                  }}
                  onMouseMove={(e) => handleResizeMouseMove(e, index)}
                  onMouseUp={handleResizeMouseUp}
                  onMouseLeave={handleResizeMouseLeave}
                >
                  <img
                    src={img.image.src}
                    alt="uploaded"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "2px solid #7F4DBE",
                    }}
                  />
                  <div
                    onMouseDown={(e) => handleResizeStart(e, index)}
                    style={{
                      position: "absolute",
                      bottom: "-5px",
                      right: "-5px",
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      background: "White",
                      cursor: "se-resize",
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <button className="grey-btn w-auto" onClick={props.onHide}>
          Cancel
        </button>
        <button onClick={handleSaveImage} className="blue-btn w-auto">
          Save Image
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAIImageModal;
